// GENERATED by scripts/gen-abis.mjs — do not edit.
export type Deployment = { chainId: number; startBlock: number; factory: `0x${string}`; weth: `0x${string}`; uniswapV2Factory: `0x${string}`; uniswapV2Router02: `0x${string}`; pairInitCodeHash: `0x${string}`; launchImplementation: `0x${string}`; tokenImplementation: `0x${string}`; owner: `0x${string}`; treasury: `0x${string}` };
export const deployments: Record<string, Deployment> = {
  "4663": {
    "chainId": 4663,
    "factory": "0x73d4f7944feBCEebB857630a79e06D645CFCb437",
    "launchImplementation": "0xc61BFE7029E53C5FA4489f611fcA5795F4f034A1",
    "owner": "0x5Fa81eB50F4a4BDA9fC736054b9c21932828E9F4",
    "pairInitCodeHash": "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
    "startBlock": 72610400,
    "tokenImplementation": "0x54DDa7896aF9402A1F988AfaF653e6014ADA4B25",
    "treasury": "0x5Fa81eB50F4a4BDA9fC736054b9c21932828E9F4",
    "uniswapV2Factory": "0x8bcEaA40B9AcdfAedF85AdF4FF01F5Ad6517937f",
    "uniswapV2Router02": "0x89e5DB8B5aA49aA85AC63f691524311AEB649eba",
    "weth": "0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73"
  },
  "31337": {
    "chainId": 31337,
    "factory": "0x5FC8d32690cc91D4c39d9d3abcBD16989F875707",
    "launchImplementation": "0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9",
    "owner": "0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266",
    "pairInitCodeHash": "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
    "startBlock": 0,
    "tokenImplementation": "0xDc64a140Aa3E981100a9becA4E685f962f0cF6C9",
    "treasury": "0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266",
    "uniswapV2Factory": "0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512",
    "uniswapV2Router02": "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0",
    "weth": "0x5FbDB2315678afecb367f032d93F642f64180aa3"
  }
};
